<template>
  <v-card
    class="fill-height validation-card-custom elevation-0"
    v-if="validations?.length > 0"
  >
    <v-card-title>{{ $t("labels.validation-standard") }}</v-card-title>
    <v-card-text class="pa-0 fill-height">
      <div
        v-for="(validation, index) in validations"
        :key="`validation-${index}`"
      >
        <v-alert
          :type="validation.type"
          :title="validation.title"
          :text="validation.description"
        />
        <br />
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
defineProps(["validations"]);
</script>

<style scoped>
.validation-card-custom {
  height: calc(100vh - 358px) !important;
  overflow-y: auto;
}
</style>
